module.exports = __webpack_public_path__ + "img/blue_154.7f084466.png";